var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProtein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.7602V0L6.85 2.05357L6.85006 3.81381L3.92507 4.54723L6.57758 5.47836C5.42866 6.00138 4.51097 6.91733 4.01217 8.04578L3.92505 8.06763L3.99234 8.09125C3.77508 8.59664 3.6415 9.14375 3.60821 9.71661L1.00006 8.80104V7.04084L3.81829 6.26995L1.00006 5.28065V3.52044L3.81832 2.74955L1 1.7602Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60084 9.90915L1.00006 10.5613V12.3215L5.58712 13.9317C4.37707 13.0162 3.6 11.5954 3.6 10C3.6 9.96965 3.60028 9.93937 3.60084 9.90915Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 15C11.6719 15 14 12.7614 14 10C14 7.23858 11.6719 5 8.8 5C5.92812 5 3.6 7.23858 3.6 10C3.6 12.7614 5.92812 15 8.8 15ZM8.8 14.375C11.3129 14.375 13.35 12.4162 13.35 10C13.35 7.58375 11.3129 5.625 8.8 5.625C6.2871 5.625 4.25 7.58375 4.25 10C4.25 12.4162 6.2871 14.375 8.8 14.375Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15 6.875H9.45V13.125H8.15V6.875Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55 9.375H12.05V10.625H5.55V9.375Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProtein);
export default __webpack_public_path__ + "static/media/AddProtein.194a4982df6c020ac9d589f183ed427d.svg";
export { ForwardRef as ReactComponent };